import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { Plan, ProyectQr } from './planes';

@Injectable()
export class User {

    database: firebase.database.Database = firebase.database();
    ruta: string = 'usuarios';

    all(role: string): Promise<UserDb[]> {
        let promise: Promise<UserDb[]> = new Promise(resolve => {
            this.database.ref(this.ruta)/* .equalTo('role', role) */.orderByChild('name').once('value').then(snap => {
                if (snap.exists()) {
                    let temp: UserDb[] = [];
                    snap.forEach((s) => {
                        temp.push(new UserDb(s.val()))
                    });
                    resolve(temp);
                } else {
                    resolve([]);
                }
            })
        });
        return promise;
    }

    allDelete(){
        let promise: Promise<UserDb[]> = new Promise(resolve => {
            this.database.ref('usuarios_borrados').orderByChild('name').once('value').then(snap => {
                if (snap.exists()) {
                    let temp: UserDb[] = [];
                    snap.forEach((s) => {
                        temp.push(new UserDb(s.val()))
                    });
                    resolve(temp);
                } else {
                    resolve([]);
                }
            })
        });
        return promise;
    }

    allPreviousRegistration(role: string): Promise<UserDb[]> {
        let promise: Promise<UserDb[]> = new Promise(resolve => {
            this.database.ref('registroPrevio')/* .equalTo('role', role) */.orderByChild('name').once('value').then(snap => {
                if (snap.exists()) {
                    let temp: UserDb[] = [];
                    snap.forEach((s) => {
                        temp.push(new UserDb(s.val()))
                    });
                    resolve(temp);
                } else {
                    resolve([]);
                }
            })
        });
        return promise;
    }

    find(id: string): Promise<UserDb> {
        let promise: Promise<UserDb> = new Promise((resolve, reject) => {
            this.database.ref(this.ruta).child(id).once('value').then(snap => {
                if (snap.exists())
                    resolve(new UserDb(snap.val()));
                else
                    reject({ error: true, message: 'no user db' });
            });
        });
        return promise;
    }

    findPreviousRegistration(id: string): Promise<UserPrev> {
        let promise: Promise<UserPrev> = new Promise(resolve => {
            this.database.ref('registroPrevio').child(id).once('value').then(snap => {
                if (snap.exists()) {
                    let user: UserDb = snap.val();
                    let userPrev = new UserPrev();
                    userPrev.baneado = user.baneado;
                    userPrev.email = user.email;
                    userPrev.id = user.id;
                    userPrev.name = user.name;
                    userPrev.plan = user.planes[0];
                    userPrev.registro = user.registro;
                    userPrev.role = user.role;
                    resolve(userPrev);
                }else{
                    resolve(null);
                }
            });
        });
        return promise;
    }
    
    async moveToTrashUser(user: UserDb){
        const _ = await this.database.ref(this.ruta).child(user.id).remove();
        return this.database.ref('usuarios_borrados').child(user.id).set(user);
    }

    removePreviousRegistration(uid: string) {
        return this.database.ref('registroPrevio').child(uid).remove();
    }

    async removeTheUserFromTheTrash(user: UserDb){
        const _ = await this.database.ref('usuarios_borrados').child(user.id).remove();
        return this.database.ref(this.ruta).child(user.id).set(user);
    }

    store(user: UserDb) {
        user.id = (user.id) ? user.id : this.database.ref(this.ruta).push().key;
        return this.database.ref(this.ruta).child(user.id).set(user);
    }

    storePreviousRegistration(user: UserDb): Promise<UserDb> {
        let promise: Promise<UserDb> = new Promise(resolve => {
            user.id = (user.id) ? user.id : this.database.ref(this.ruta).push().key;
            this.database.ref('registroPrevio').child(user.id).set(user);
            resolve(user);
        });
        return promise;
    }

    update(user: UserDb) {
        return this.database.ref(this.ruta).child(user.id).set(user);
    }

    updateChild(userId: string, child: string, value: any) {
        return this.database.ref(this.ruta).child(userId).child(child).set(value);
    }
}

export class UserDb {
    baneado: boolean;
    codigosQr: ProyectQr[];
    domicilio: string;
    email: string;
    id: string;
    name: string;
    nifCif: string;
    planes: string[];
    proyectosEdit: boolean;
    proyectosEditPass: string;
    registro: number;
    role: string;
    telefono: string;

    constructor(user?: UserDb) {
        this.baneado = user ? user.baneado : false;
        this.codigosQr = user ? user.codigosQr : [];
        this.domicilio = user ? user.domicilio : '';
        this.email = user ? user.email : '';
        this.id = user ? user.id : null;
        this.name = user ? user.name : '';
        this.nifCif = user ? user.nifCif : '';
        this.planes = user ? user.planes : [];
        this.proyectosEdit = user ? user.proyectosEdit : true;
        this.proyectosEditPass = user ? user.proyectosEditPass : '123456';
        this.registro = user ? user.registro : new Date().getTime();
        this.role = user ? user.role : 'user';
        this.telefono = user ? user.telefono : '';
    }
}

export class UserHtml {
    baneado: boolean;
    codigosQr: ProyectQr[];
    domicilio: string;
    email: string;
    id: string;
    name: string;
    nifCif: string;
    planes: Plan[];
    proyectosEdit: boolean;
    proyectosEditPass: string;
    registro: number;
    role: string;
    telefono: string;

    constructor(user: UserDb, planes: Plan[]) {
        this.baneado = user.baneado;
        this.codigosQr = user.codigosQr;
        this.domicilio = user.domicilio;
        this.email = user.email;
        this.id = user.id;
        this.name = user.name;
        this.nifCif = user.nifCif;
        this.planes = planes;
        this.proyectosEdit = user.proyectosEdit;
        this.proyectosEditPass = user.proyectosEditPass;
        this.registro = user.registro;
        this.role = user.role;
        this.telefono = user.telefono;
    }
}

export class UserPrev {
    baneado: boolean;
    email: string;
    id: string;
    name: string;
    plan: string;
    registro: number;
    role: string;

    constructor(user?: UserPrev) {
        this.baneado = user ? user.baneado : false;
        this.email = user ? user.email : '';
        this.id = user ? user.id : null;
        this.name = user ? user.name : '';
        this.plan = user ? user.plan : '';
        this.registro = user ? user.registro : new Date().getTime();
        this.role = user ? user.role : 'user';
    }
}

export class NewUserFinish {
    domicilio: string;
    email: string;
    name: string;
    nifCif: string;
    pass: string;
    passRepeat: string;
    plan: Plan;
    role: string;
    telefono: string;

    constructor(user: UserPrev, plan: Plan) {
        this.domicilio = '';
        this.email = user.email;
        this.name = user.name;
        this.nifCif = '';
        this.pass = '';
        this.passRepeat = '';
        this.plan = plan;
        this.role = user.role;
        this.telefono = '';
    }
}


// WEBPACK FOOTER //
// ./src/app/providers/user.ts